import { useParams } from "react-router-dom";
import TranslatorView from "./../components/TranslatorView.react";

export default function TranslatorViewRoute(): React$Element<any> {
  let params = useParams();
  return <TranslatorView sessionId={params.sessionId} />;
}
